/* eslint-disable import/prefer-default-export */
import { createUrl } from '_clean-code/utils/urlHelper';
import apiClient from '../../api/index';
import {
  IMachineService,
  MachineListResponse,
  StatusResponse
} from './contracts/machine-service';

export const MachineService: IMachineService = {
  async getStatus(machineIds: number[]): Promise<StatusResponse[]> {
    if (machineIds.length === 0) return [];
    const response = (await apiClient.request(
      'GET',
      createUrl('/machines/status')
        .addQueryParamMany('id', machineIds)
        .toStringUrl()
    )) as StatusResponse[];

    return response.map((x) => ({
      ...x,
      startTime: new Date(x.startTime),
      endTime: new Date(x.endTime)
    }));
  },
  async getMachines() {
    const response = (await apiClient.request(
      'GET',
      createUrl('/machine/list').toStringUrl()
    )) as MachineListResponse;
    return response;
  }
};
